import React from 'react';
import { Checkbox } from './ui/checkbox';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';

export const IstatNetworkOption = ({ propertyId, checked, disabled, onChange }) => (
  <label className="flex items-start gap-2 text-sm text-slate-700 py-2" data-testid={`network-option-${propertyId}`}>
    <Checkbox checked={checked} disabled={disabled} onCheckedChange={value => onChange(value === true)}
      data-testid={`network-enable-${propertyId}`} aria-label="Diagnosi rete per il prossimo invio giornaliero" />
    <span>Diagnosi rete per il prossimo invio giornaliero</span>
  </label>
);

export const IstatNetworkConfirm = ({ pending, onCancel, onConfirm }) => (
  <AlertDialog open={Boolean(pending)} onOpenChange={open => { if (!open) onCancel(); }}>
    <AlertDialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-lg" data-testid="network-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="network-confirm-title">Confermi l’invio alla Calabria?</AlertDialogTitle>
        <AlertDialogDescription data-testid="network-confirm-description">
          Verranno inviati i movimenti del {pending?.targetDate} al portale regionale, registrando la diagnosi di rete.
          {' '}Non è una simulazione. Gli invii automatici non cambiano.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel} data-testid="network-confirm-cancel">Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} data-testid="network-confirm-send">Invia con diagnosi</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);